﻿import $ from "jquery";
import tinymce from 'tinymce';
import { showMessage, initTinymce } from "./main";

$(() => {
    var currentPage = $("#currentPage").val();
    if (currentPage != "toolDetail") return;

    init();
});

function init() {
    initToolSave();
}

function initToolSave() {
    $("#btnSave").on('click', function () {

        var data = $('#frmTool').serialize();

        var formData = {
            Title: $('#Title').val(),
            HtmlContent: $('#HtmlContent').val()
        };

        let request = $.ajax({
            type: 'Post',
            url: '/Tool/RemoveClassAttributes/',
            data: JSON.stringify(formData),
            contentType: 'application/json',
            beforeSend: function () {
                $('#spinnerContainer').removeClass('d-none');
            },
            complete: function () {
                $('#spinnerContainer').addClass('d-none');
            }
        });

        request.done(function (res) {
            if (res.error == true) {
                showMessage(res.message, "Chyba!");
            }
            else {
                $('#contentContainer').html(res.html);
            }
        });
        request.fail(function (jqXHR) {
            console.error(jqXHR)
        });
    });
}

